module.exports = __webpack_public_path__ + "static/media/20201114_162010_055_IMG_0031.6f6c6bee.jpg";